<template>
  <div>
    <v-text-field
      v-model="cmpValue"
      :label="label"
      :placeholder="placeholder"
      persistent-placeholder
      persistent-hint
      :rules="rules"
      :maxlength="maxLength"
      class="text-caption"
      dense
      outlined
      :dark="dark"
      validate-on-blur
      @change="updateValue"
      @blur="blurValue"
      @click="$emit('click')"
      @focus="$emit('focus')"
      @keydown="$emit('keydown')"
      @mousedown="$emit('mousedown')"
      @mouseup="$emit('mouseup')"
      @focusin="$emit('focusin')"
      @focusout="$emit('focusout')"
      v-bind="$attrs"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: { prop: 'value', event: 'input' },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxLength: {
      type: [Number],
      default: 0,
    },
    minLength: {
      type: [Number],
      default: 0,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    cmpValue: {
      get: function() {
        return this.value
      },
      set: function(newValue) {
        this.$emit('input', newValue)
      },
    },
    rules() {
      const rules = []

      if (this.minLength > 0) {
        const rule = (value) => {
          value = typeof value == 'number' ? value.toString() : value

          return (
            (value && value.length >= this.minLength) ||
            this.$i18n.t('validation-messages.minLength', {
              quantidade: this.minLength,
            })
          )
        }
        rules.push(rule)
      }

      if (this.maxLength > 0) {
        const rule = (value) => {
          if (!value) {
            return true
          }

          value = typeof value == 'number' ? value.toString() : value

          return (
            (value.length > 0 && value.length <= this.maxLength) ||
            this.$i18n.t('validation-messages.maxLength', {
              quantidade: this.maxLength,
            })
          )
        }
        rules.push(rule)
      }

      if (this.isRequired) {
        const rule = (value) =>
          !!value || this.$i18n.t('validation-messages.requiredField')
        rules.push(rule)
      }

      return rules
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    blurValue(value) {
      this.$emit('blur', value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
